"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    type: 'danger',
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, "Hover me ", /*#__PURE__*/_react.default.createElement(_icons.DownOutlined, null)), /*#__PURE__*/_react.default.createElement(_antd.Dropdown._InternalPanelDoNotUseOrYouWillBeFired, {
    menu: {
      items: [{
        label: 'item 1',
        key: '1'
      }, {
        label: 'a danger item',
        danger: true,
        key: '3'
      }, {
        label: 'danger disabled item',
        danger: true,
        disabled: true,
        key: '2'
      }]
    }
  }));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorError', 'colorErrorHover', 'colorBgElevated'],
  key: 'default'
};
var _default = exports.default = componentDemo;